import styled, { css } from 'styled-components';
import { Grid, mediaMixin } from '@zillow/constellation';

export const StyledGrid = styled(Grid)`
  position: relative;
`;

const getMobileGridStyle = (props: { alwaysShowProgressMeterTitle: boolean; showDesktopViewBreakpoint: string }) => {
  if (props.alwaysShowProgressMeterTitle) {
    return css``;
  }

  return mediaMixin(
    props.showDesktopViewBreakpoint,
    css`
      display: none;
    `,
  );
};

export const StyledMobileGrid = styled(Grid)`
  ${getMobileGridStyle}
`;
